import { render, staticRenderFns } from "./SubFrequencyTag.vue?vue&type=template&id=280043ae&scoped=true&lang=pug&"
import script from "./SubFrequencyTag.vue?vue&type=script&lang=js&"
export * from "./SubFrequencyTag.vue?vue&type=script&lang=js&"
import style0 from "./SubFrequencyTag.vue?vue&type=style&index=0&id=280043ae&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280043ae",
  null
  
)

export default component.exports